// extracted by mini-css-extract-plugin
export default {"root":"qDSBo2"};